import { SignInOutInitialStateType } from 'src/pages/Account/Profile/Signin/store/slice';
import { RootState } from 'src/store/store';

/** entered email page info */
export const signInAccountResponseSelector = ({
  signInOut: { accountResponse },
}: RootState): SignInOutInitialStateType['accountResponse'] => accountResponse;

/** which account mode(tab) is active  */
export const signInOutSelector = ({ signInOut }: RootState): SignInOutInitialStateType => signInOut;

/** email which has been entered on login page */
export const accountEnteredEmailSelector = ({
  signInOut: { enteredEmail },
}: RootState): SignInOutInitialStateType['enteredEmail'] => enteredEmail;

/** signup page info */
export const accountSignUpSelector = ({ signInOut: { signUp } }: RootState): SignInOutInitialStateType['signUp'] =>
  signUp;
